import Analytics from "analytics"
import { getAnalytics, logEvent } from "firebase/analytics"
import { FirebaseOptions, initializeApp } from "firebase/app"

import googleAnalytics from "@analytics/google-analytics"
import { firebaseConfig } from "@config/firebase"
import googleAnalyticsConfig from "@config/google-analytics"

import isDevelopment from "../utils/isDevelopment"

interface Payload {
    event: string
    properties: {}
}

const fireBasePlugin = ({ ...userConfig } = {}) => ({
    name: "firebase-analytics-plugin",
    enabled: !isDevelopment,
    config: {
        ...userConfig
    },
    initialize: ({ config }: { config: FirebaseOptions }) => {
        initializeApp(config)
    },
    page: () => {
        getAnalytics()
    },
    track: ({ payload }: { payload: Payload }) => {
        const analytics = getAnalytics()
        logEvent(analytics, payload.event, payload.properties)
    }
})

const facebookPixelPlugin = () => ({
    name: "facebook-ads",
    enabled: !isDevelopment,
    initialize: async () => {},
    page: () => {
        window.fbq("track", "PageView")
    },
    track: ({ payload }: { payload: Payload }) => {
        window.fbq("track", payload.event, payload.properties)
    },
    loaded: () => window?.fbq?.loaded
})

const plugins: any[] = [
    fireBasePlugin(firebaseConfig),
    facebookPixelPlugin(),
    googleAnalytics({
        ...googleAnalyticsConfig,
        enabled: !isDevelopment
    })
]

const analytics = Analytics({
    app: "rekeningku-next",
    plugins
})

export default analytics
